
































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import baseSpinner from "@/components/Spinner";
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import PatternMakerSwatchesCarousel from '@/components/molecule.patternMaker.swatchesCarousel.vue';
import PatternMakerStickersCarousel from '@/components/molecule.patternMaker.stickersCarousel.vue';
import PatternMakerStickerTabs from "@/components/molecule.patternMaker.stickerTabs.vue";

import sceneManager from "@/mixins/Customizer/SceneManager";
import modelHelpers from "@/mixins/Customizer/ModelHelpers";
import patternMaker from "@/mixins/PatternMaker";
import undo from "@/mixins/Customizer/Undo";
import geometryUpdate from '@/mixins/geometryUpdates';

@Component({
  components: {
    CustomContainer,
    CustomImage,
    baseSpinner,
    CustomButton,
    ModalHeader,
    CustomText,
    PatternMakerSwatchesCarousel,
    PatternMakerStickersCarousel,
    PatternMakerStickerTabs
  },
  mixins:[ sceneManager, modelHelpers, patternMaker, undo, geometryUpdate ],
})
export default class PatternMakerView extends Vue {
  isBackButtonVisible: boolean = false;

  @Prop({default: () => []})
  stickersId!: any[];

  @Prop({default: false})
  isMainApp!: boolean;

 @Prop({default: true})
  slideToSelectedItems!: boolean;

  closeAction() {
    this.$modal.hide('patternMaker');
  }

  created() {
    (this as any).setInitialValues();
    this.$eventBus.$on('hide-pattern-maker', (this as any).closeModalOption);
    window.addEventListener('resize', (this as any).checkEnableCarouselNavigation);
  }

  beforeDestroy() {
    this.$eventBus.$off('hide-pattern-maker', (this as any).closeModalOption);
    window.removeEventListener('resize', (this as any).checkEnableCarouselNavigation);
  }

  mounted() {
    (this as any).checkEnableCarouselNavigation();
  }
}
